import axios from 'axios';
import { pushgetApiResponse, pushPostApiResponse, pushDeleteSelectedItem, pushPutApiResponse } from '../slices/customQueryHeaderSlice';
import Cookies from 'js-cookie';
let tenantUrl = Cookies.get('tenantUrl');
import consts from '../utils/consts';
const {
  baseUrlquery
} = consts;

const handleError = async error => {
  if (error.response) {
    const {
      status
    } = error.response;

    if (status === 400) {
      window.location.replace('/');
    }

    if (status === 403) {
      window.location.replace('/access-denied');
    } // always return the error


    return Promise.reject(error);
  }
};

export const getResponseAPIData = (urlArray, type) => dispatch => {
  let formedGetRequests = urlArray.map(url => {
    return axios.get(tenantUrl + url, {
      withCredentials: true
    });
  });
  dispatch(pushgetApiResponse({
    data: {
      isLoading: true
    },
    type
  }));
  return axios.all(formedGetRequests).then(data => {
    dispatch(pushgetApiResponse({
      data: { ...data,
        isLoading: false
      },
      type
    }));
  }).catch(error => {
    dispatch(pushgetApiResponse({
      data: {
        isLoading: false
      },
      type
    }));
    handleError(error);
  });
};
export const getPostResponseAPIData = (urlArray, urlRequest, type) => dispatch => {
  let formedPostRequests = urlArray.map(url => {
    return axios.post(tenantUrl + url, urlRequest, {
      withCredentials: true
    });
  });
  axios.all(formedPostRequests).then(data => {
    dispatch(pushPostApiResponse({
      data,
      type
    }));
  }).catch(handleError);
};
export const getPutResponseAPIData = (urlArray, urlRequest, type) => dispatch => {
  let formedPostRequests = urlArray.map(url => {
    return axios.put(tenantUrl + url, urlRequest, {
      withCredentials: true
    });
  });
  axios.all(formedPostRequests).then(data => {
    dispatch(pushPutApiResponse({
      data,
      type
    }));
  }).catch(handleError);
};
export const deleteResponseAPIData = (id, name, count, type) => dispatch => {
  let apiUrl = `${baseUrlquery}queries/${id}?queryName=${name}`;
  axios.delete(tenantUrl + apiUrl, {
    withCredentials: true
  }).then(data => {
    dispatch(pushDeleteSelectedItem({
      id,
      data,
      count,
      type
    }));
  }).catch(handleError);
};
export const getPostResponseCSV = (urlArray, apiUrl, urlRequest, type) => dispatch => {
  let index = 1;
  let responseData = [];
  let apiValue = apiUrl + `limit=50000&offset=`;

  function apiRequest() {
    return axios.post(tenantUrl + apiValue + index, urlRequest, {
      withCredentials: true
    }).then(response => {
      index++;
      responseData.push(response.data.queryData);
      let data = [].concat.apply([], responseData);

      if (index >= urlArray.length + 1) {
        return dispatch(pushPostApiResponse({
          data,
          type
        }));
      }

      return apiRequest();
    }).catch(handleError);
  }

  return apiRequest();
};